import { Routes } from '@angular/router';

import { MpsIsAdminGuard } from '../mps/guards/mps-isadmin.guard';
import { MpsSubsidiaryDataGuard } from '../mps/guards/mps-subsidiary-data.guard';
import { applicationRouteNames } from './application-route-names';

export const applicationRoutes: Routes = [
  {
    // Home retiré du menu : /home (cible du redirect post-login EntraID) redirige vers Reports.
    path: applicationRouteNames.home,
    redirectTo: applicationRouteNames.reports,
    pathMatch: 'full',
  },
  {
    // Reports promu en entrée de menu de premier niveau (sorti de l'administration).
    path: applicationRouteNames.reports,
    loadComponent: () => import('./administration/reports/list/list.component').then((m) => m.ListComponent),
    data: { title: 'general.navigation.reports' },
    canActivate: [MpsSubsidiaryDataGuard],
    canLoad: [MpsSubsidiaryDataGuard],
  },
  {
    path: applicationRouteNames.administration,
    data: { title: 'general.navigation.administration' },
    // La section admin est accessible aux admins globaux ET aux admins de filiale.
    // Le cloisonnement fin est fait par les guards enfants + le scoping backend.
    canActivate: [MpsSubsidiaryDataGuard],
    canLoad: [MpsSubsidiaryDataGuard],
    children: [
      {
        path: applicationRouteNames.users,
        loadComponent: () => import('./administration/users/list/list.component').then((m) => m.ListComponent),
        data: { title: 'general.navigation.users' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.subsidiaries,
        loadComponent: () => import('./administration/subsidiaries/list/list.component').then((m) => m.ListComponent),
        data: { title: 'general.navigation.subsidiaries' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.contacts,
        loadComponent: () => import('./administration/contacts/list/list.component').then((m) => m.ListComponent),
        data: { title: 'general.navigation.contacts' },
        canActivate: [MpsSubsidiaryDataGuard],
        canLoad: [MpsSubsidiaryDataGuard],
      },
      // Lokalise masqué du back-office : accès retiré (menu + URL), composant conservé
      // dans administration/lokalise. Pour le réactiver, décommenter ce bloc.
      // {
      //   path: applicationRouteNames.lokalise,
      //   loadComponent: () => import('./administration/lokalise/lokalise.component').then((m) => m.LokaliseComponent),
      //   data: { title: 'general.navigation.lokalise' },
      //   canActivate: [MpsIsAdminGuard],
      //   canLoad: [MpsIsAdminGuard],
      // },
    ],
  },
];
